import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { LocalStorageService } from 'app/shared/services/local-storage.service';

export const LoggedInGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const localStorageService = inject(LocalStorageService);

  const isLoggedIn = authService.isAuthenticated;

  if (!isLoggedIn) return true;

  const businessId: string = localStorageService.getItem('active_business');

  router.navigate([`/business`, businessId]);

  return false;
};
